import { gql } from '@apollo/client';

export interface TrackEventResponse {
  trackAnalyticsEvent: null;
}

export interface TrackEventVariables {
  event: string;
  anonymousId?: string;
  userIdOverride?: string;
  properties?: Record<string, unknown>;
}

export const TRACK_EVENT = gql`
  mutation TrackEvent(
    $event: String!
    $anonymousId: String
    $userIdOverride: String
    $properties: Json
  ) {
    trackAnalyticsEvent(
      event: $event
      anonymousId: $anonymousId
      userIdOverride: $userIdOverride
      properties: $properties
    )
  }
`;
